// A simpler alternative to Header.jsx for pages that want their header
// content (e.g. a filter bar) always visible and pinned to the right,
// instead of hidden behind a collapse toggle. Reuses the same header-block/
// header-panel/header-txt classes so it still looks like the rest of the app.
export default function PageHeader({ name, children }) {
    return (
        <header className="header-block">
            <div className="header-panel" style={{ justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap", gap: 8 }}>
                <div className="header-txt">{name}</div>
                {children}
            </div>
        </header>
    );
}
